import { postRequest } from '../../shared/utils';

export function convertToDatabaseColumns({ xlsxRow, columnMapping }) {
  return Object.keys(xlsxRow).reduce((acc, column) => {
    const dbColumn = columnMapping[column];
    if (dbColumn) {
      acc[dbColumn] = xlsxRow[column];
    }
    return acc;
  }, {});
}

export function convertDropdownLabelsToValues({ row, dropdownMapping }) {
  return Object.keys(row).reduce((acc, column) => {
    const dropdown = dropdownMapping[column];
    if (!dropdown) {
      acc[column] = row[column];
    } else {
      const dropdownOption = dropdown.find((item) => item.label === row[column]);
      acc[column] = dropdownOption ? dropdownOption.value : 1;
    }
    return acc;
  }, {});
}

export function convertGmtDatesToUTCStrings({ row }) {
  return Object.keys(row).reduce((acc, column) => {
    if (row[column] instanceof Date) {
      const dateFromXlsx = row[column];
      const date = `${dateFromXlsx.getFullYear()}-${dateFromXlsx.getMonth() + 1}-${dateFromXlsx.getDate()}`;
      acc[column] = date;
    } else {
      acc[column] = row[column];
    }
    return acc;
  }, {});
}

export async function getIdFromEsaph({ npiHtz, schemaName, screenGridId }) {
  const body = {
    columns: ['id'],
    screenGridId,
    schema: schemaName,
    table: 'e_saph',
    key: 'htz',
    value: npiHtz,
  };
  const { data } = await postRequest('/api/records', body);
  return data?.[`${schemaName}_e_saph`]?.length ? data[`${schemaName}_e_saph`][0].id : null;
}

export function isFastTrackMoB({ mob, labelValueMapping }) {
  const fastTrackMoBValues = [1, 12, 13, 16, 17, 18, 19];
  const value = labelValueMapping.find((item) => item.label === mob)?.value || null;
  return fastTrackMoBValues.includes(value);
}

export function convertNumbers({ row, allAccessibleColumns }) {
  return Object.keys(row).reduce((acc, columnName) => {
    const colDef = allAccessibleColumns.find((col) => col.attrInternalName === columnName);
    const value = row[columnName];
    if (value === null || value === undefined || value === '') {
      return acc;
    }
    if (colDef && ['string', 'textarea'].includes(colDef.attrDataType)) {
      acc[columnName] = '' + row[columnName];
    } else {
      acc[columnName] = row[columnName];
    }
    return acc;
  }, {});
}
